import * as Sentry from '@sentry/react';
const privateSetup = /\/(payment-method\/setup|payment-method-setups)\/|https:\/\/(verify|payments)\.stripe\.com\//;

function parseOptionalNumber(rawValue: string | undefined): number | undefined {
  if (!rawValue) return undefined;
  const parsed = Number(rawValue);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function initFrontendSentry(): boolean {
  const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
  if (!dsn) {
    return false;
  }

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    tracesSampleRate: parseOptionalNumber(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE),
    beforeSend(event) {
      return privateSetup.test(window.location.pathname + ' ' + (event.request?.url || '')) ? null : event;
    },
    beforeSendTransaction(event) {
      return privateSetup.test(window.location.pathname + ' ' + (event.request?.url || event.transaction || '')) ? null : event;
    },
    beforeBreadcrumb(breadcrumb) {
      return privateSetup.test(window.location.pathname + ' ' + String(breadcrumb.data?.url || '') + ' ' + (breadcrumb.message || '')) ? null : breadcrumb;
    },
  });

  return true;
}
